export { default as EditCommunicationPreferences } from './EditCommunicationPreferences';
